import React, { Component } from 'react'

export default class Divider extends Component {
    render() {
        return (
            <div>
                 
                   <div id="divider">
                   <main id="main">
                   <section id="features">
      <div class="container">

        <div class="row feature-item">
          <div class="col-lg-6 wow fadeInUp">
            <img src="assets/img/features-1.svg" class="img-fluid" alt=""/>
          </div>
          <div class="col-lg-6 wow fadeInUp pt-5 pt-lg-0">
            <h4>  <h2 class="wow bounce">We provide <strong>solutions</strong></h2>
</h4>
            Improve yourself  and learn responsive  web design fundamentals.
<p>• Stay up to date – Get updated files when framework minor updates are made to help you stay current.</p> 
<p>• Connect – Ask questions and get to know other web designers.</p>

          </div>
        </div>

        <div class="row feature-item mt-5 pt-5">
          <div class="col-lg-6 wow fadeInUp order-1 order-lg-2">
            <img src="assets/img/features-2.svg" class="img-fluid" alt=""/>
          </div>

          <div class="col-lg-6 wow fadeInUp pt-4 pt-lg-0 order-2 order-lg-1">
            <h4 class="wow fadeIn" data-wow-delay="0.6s"><mark>Creative</mark> Designers &amp;
                                       <mark>  Talented</mark> Developers</h4>
            <p> • Stand out – Improve  by being proficient in the most popular front-end CSS framework.</p> 
<p>• Be more efficient – Learn what’s new and how it can help you earn more in less time by boosting your productivity.</p> 

          </div>
          
        </div>

      </div>
    </section>
    </main>
                        <div class="container">
                            <div class="row">
                                <div class="col-md-1 col-sm-1"></div>
                                <div class="col-md-8 col-sm-8">
                                   
                                    <p class="wow fadeInUp" data-wow-delay="0.9s"></p>

                                </div>
                                <div class="col-md-2 col-sm-2"></div>
                            </div>
                        </div>
                    </div>
            </div>
        )
    }
}
